<mat-calendar
  [startAt]="startAt || value"
  [minDate]="_minCal"
  [maxDate]="_maxCal"
  [dateFilter]="dateFilter"
  [selected]="value"
  [dateClass]="dateClass"
  (selectedChange)="setDate($event)"
>
</mat-calendar>
<nk-time-edit
  *ngIf="!hideTime"
  [showMeridian]="showMeridian"
  [showMilliseconds]="showMilliseconds"
  [showSeconds]="showSeconds"
  [min]="min"
  [max]="max"
  [(value)]="value"
  [disabled]="disabled || !value"
  (userSelection)="userSelection.emit($event);_onUserInput($event)"
>
</nk-time-edit>
<div class="nk-datetime-footer">
  <ng-content></ng-content>
</div>
